import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";

function statusLabel(status, self = false) {
  if (status === "showed_up") return self ? "Done" : "Submitted";
  if (status === "small_version") return self ? "Done" : "Submitted";
  if (status === "reset") return "Reset";
  if (status === "no_report") return "No report";
  return self ? "Not submitted yet" : "Not submitted";
}

function statusBody({ viewerStatus, partnerStatus, partnerName }) {
  const viewerDone = ["showed_up", "small_version", "reset"].includes(String(viewerStatus || ""));
  const partnerDone = ["showed_up", "small_version", "reset"].includes(String(partnerStatus || ""));
  if (viewerDone && partnerDone) return "Both Daily Reports are done today.";
  if (partnerDone) return `${partnerName} submitted today. Your report is still open.`;
  if (viewerDone) return `Your report is in. ${partnerName} has not submitted yet.`;
  return "Every day ends with a Daily Report: Done, Reset, or No report.";
}

export default function ChallengeShowUpCard({
  partnerName,
  sprintMode,
  viewerStatusToday,
  partnerStatusToday,
  onShowUpStatus,
  onDoOneStep,
  onAttachPhotoProof,
  onSubmitTimerReport,
  onAcknowledgePartnerReport,
}) {
  return (
    <Box
      sx={{
        border: "1px solid #dde5ef",
        borderRadius: "8px",
        background: "#fff",
        p: 2,
        boxShadow: "0 10px 28px rgba(15, 31, 53, 0.06)",
      }}
    >
      <Stack spacing={1.4}>
        <Box>
          <Typography sx={{ fontSize: 18, lineHeight: "22px", fontWeight: 850, color: "#13233d" }}>
            Today’s Daily Report
          </Typography>
          <Typography sx={{ fontSize: 14, lineHeight: "20px", color: "#5b6778", mt: 0.35 }}>
            {statusBody({ viewerStatus: viewerStatusToday, partnerStatus: partnerStatusToday, partnerName })}
          </Typography>
        </Box>

        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 1 }}>
          <Box sx={{ border: "1px solid #e4ebf3", borderRadius: "8px", p: 1.2, background: "#f7f9fc" }}>
            <Typography sx={{ fontSize: 11, fontWeight: 850, color: "#7b8796", textTransform: "uppercase" }}>You</Typography>
            <Typography sx={{ fontSize: 14, fontWeight: 850, color: "#13233d" }}>{statusLabel(viewerStatusToday, true)}</Typography>
          </Box>
          <Box sx={{ border: "1px solid #e4ebf3", borderRadius: "8px", p: 1.2, background: "#f7f9fc" }}>
            <Typography sx={{ fontSize: 11, fontWeight: 850, color: "#7b8796", textTransform: "uppercase" }}>{partnerName}</Typography>
            <Typography sx={{ fontSize: 14, fontWeight: 850, color: "#13233d" }}>{statusLabel(partnerStatusToday)}</Typography>
          </Box>
        </Box>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
          <Button variant="contained" onClick={onDoOneStep} sx={{ textTransform: "none", borderRadius: "8px", fontWeight: 850, backgroundColor: "#172b49" }}>
            Done
          </Button>
          <Button variant="outlined" onClick={() => onShowUpStatus("reset")} sx={{ textTransform: "none", borderRadius: "8px", fontWeight: 850 }}>
            Reset
          </Button>
          <Button variant="outlined" onClick={onSubmitTimerReport} sx={{ textTransform: "none", borderRadius: "8px", fontWeight: 850 }}>
            5-minute proof
          </Button>
          <Button variant="outlined" component="label" sx={{ textTransform: "none", borderRadius: "8px", fontWeight: 850 }}>
            Photo proof
            <input
              hidden
              accept="image/*"
              type="file"
              onChange={(event) => {
                const file = event.target.files?.[0];
                if (file && onAttachPhotoProof) onAttachPhotoProof(file);
                event.target.value = "";
              }}
            />
          </Button>
          {onAcknowledgePartnerReport ? (
            <Button variant="text" onClick={onAcknowledgePartnerReport} sx={{ textTransform: "none", borderRadius: "8px", fontWeight: 850 }}>
              Proof looks good
            </Button>
          ) : null}
        </Stack>
      </Stack>
    </Box>
  );
}
